import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import moment from 'moment';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { archiveReport, getReports } from 'redux/modules/reporting';
import { EmptyState, Spinner } from 'components';
import RaisedButton from 'material-ui/RaisedButton';
import styles from './ClientDetailReportList.scss';
var ClientDetailReportList = (_dec = connect(function (state, props) {
  var orgId = props.orgId;
  return {
    gettingReports: state.reporting.gettingReports,
    reports: state.reporting.reports && state.reporting.reports[orgId] ? state.reporting.reports[orgId] : [],
    theme: state.theme
  };
}, {
  archiveReport: archiveReport,
  getReports: getReports
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ClientDetailReportList, _Component);

  var _super = _createSuper(ClientDetailReportList);

  function ClientDetailReportList(props) {
    var _this;

    _classCallCheck(this, ClientDetailReportList);

    _this = _super.call(this, props);
    _this.state = {
      showArchived: false
    };
    return _this;
  }

  _createClass(ClientDetailReportList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getReports(this.props.orgId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Build New Report",
        onClick: function onClick() {
          browserHistory.push("/global/report-builder/org/".concat(_this2.props.orgId, "/reportType/socialMediaSummary"));
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.reportListWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.header
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.headerText, " ").concat(styles.title)
      }, "Report Name"), /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.headerText, " ").concat(styles.dateRange)
      }, "Date Range"), /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.headerText, " ").concat(styles.created)
      }, "Created"), /*#__PURE__*/React.createElement("div", {
        className: styles.controlsWrap
      })), this.props.reports && !!this.props.reports.length && this.props.reports.filter(function (r) {
        return _this2.state.showArchived ? r.isArchived : !r.isArchived;
      }).map(function (report, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: styles.listRow,
          key: index
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.title
        }, _this2.state.showArchived && /*#__PURE__*/React.createElement("span", {
          style: {
            fontStyle: 'italic'
          }
        }, "Archived -- "), report.name), /*#__PURE__*/React.createElement("span", {
          className: styles.dateRange
        }, "".concat(moment(report.startDate).format('MM/DD/YYYY'), " - ").concat(moment(report.endDate).format('MM/DD/YYYY'), " ")), /*#__PURE__*/React.createElement("span", {
          className: styles.created
        }, "".concat(moment(report.createdAt).format('MM/DD/YYYY - h:mm a'))), /*#__PURE__*/React.createElement("div", {
          className: styles.controlsWrap
        }, !_this2.state.showArchived && /*#__PURE__*/React.createElement("span", {
          className: styles.listItemControl,
          onClick: function onClick() {
            browserHistory.push({
              pathname: "/global/report-builder/org/".concat(report.OrganizationId, "/report/").concat(report.id)
            });
          }
        }, "Edit"), /*#__PURE__*/React.createElement("span", {
          className: styles.listItemControl,
          onClick: function onClick() {
            browserHistory.push({
              pathname: "/org/".concat(report.OrganizationId, "/reports/").concat(report.reportType === 'monthly' ? 'summary' : report.reportType === 'facebookChecklist' ? 'facebook-facelift' : 'upcoming-content', "/").concat(report.id)
            });
          }
        }, "View"), report.S3File ? /*#__PURE__*/React.createElement("span", {
          className: styles.listItemControl
        }, /*#__PURE__*/React.createElement("a", {
          href: report.S3File.fullyQualifiedUrl,
          target: "_blank",
          style: {
            color: 'inherit',
            textDecoration: 'none'
          }
        }, "Download")) : /*#__PURE__*/React.createElement("span", {
          className: styles.listItemControl,
          style: {
            visibility: 'hidden'
          }
        }, "Download"), !_this2.state.showArchived && /*#__PURE__*/React.createElement("span", {
          className: styles.listItemControl,
          onClick: function onClick() {
            _this2.props.archiveReport(report.OrganizationId, report.id);
          }
        }, "Archive")));
      }), (!this.props.reports || !this.props.reports.length) && this.props.gettingReports && /*#__PURE__*/React.createElement("div", {
        style: {
          height: 75,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), this.props.reports && !this.props.reports.length && !this.props.gettingReports && /*#__PURE__*/React.createElement(EmptyState, {
        buttonLabel: "Build A Report",
        buttonOnClick: function buttonOnClick() {
          browserHistory.push('/global/report-builder');
        },
        text: "".concat(this.props.orgName, " has no reports yet."),
        iconName: "fa fa-rocket",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      })), /*#__PURE__*/React.createElement(RaisedButton, {
        label: this.state.showArchived ? 'Show Active Reports' : 'Show Archived Reports',
        onClick: function onClick() {
          _this2.setState({
            showArchived: !_this2.state.showArchived
          });
        },
        style: {
          "float": 'right',
          marginTop: 24
        }
      }));
    }
  }]);

  return ClientDetailReportList;
}(Component)) || _class);
export default ClientDetailReportList;